import { Label } from "reactstrap";
import Select from "react-select";
import { useMemo, useState } from "react";

const colourStyles: any = {
  multiValueLabel: (styles: any, { data }: any) => ({
    ...styles,
    color: "#ffffff",
  }),
};

const BaseSelect = ({
  label,
  name,
  className,
  options,
  title,
  placeholder,
  required,
  handleChange,
  handleBlur,
  value,
  touched,
  error,
  isDisabled,
  addOptionLabel,
}: any) => {
  const [inputValue, setInputValue] = useState("");
  const selectedValue =
    options?.find((option: any) => option.value === value) || null;

  const handleChangeWrapper = (selectedOption: any) => {
    handleChange(name, selectedOption ? selectedOption.value : "");
  };

  const filteredOptions = useMemo(() => {
    if (!inputValue) return options;
    const matches = options.filter((option: any) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    const isAddOptionVisible = matches.length === 0 && !!addOptionLabel;
    if (isAddOptionVisible) {
      return [
        {
          value: addOptionLabel,
          label: addOptionLabel,
        },
      ];
    }
    return matches;
  }, [inputValue, options, addOptionLabel]);

  return (
    <>
      {label && (
        <Label htmlFor={name} className="form-label">
          {label}
          {required && <span className="text-danger">*</span>}
        </Label>
      )}
      <Select
        name={name}
        id={name}
        title={title}
        className={className ? className : "select-border"}
        options={filteredOptions}
        placeholder={placeholder}
        invalid={!!(error && touched)}
        value={selectedValue}
        isClearable
        onChange={handleChangeWrapper}
        onBlur={handleBlur}
        isInvalid={!!(touched && error)}
        isDisabled={isDisabled}
        onInputChange={(newValue: any) => {
          setInputValue(newValue);
          return newValue;
        }}
        filterOption={() => true}
        menuPortalTarget={document.body}
        styles={{
          ...colourStyles,
          menuPortal: (base:any) => ({ ...base, zIndex: 9999 }),
        }}
      />
      {touched && error ? (
        <div className="text-danger error-font">{error}</div>
      ) : null}
    </>
  );
};

const MultiSelect = ({
  label,
  value,
  isMulti,
  onChange,
  options,
  touched,
  error,
  name,
  handleBlur,
  className,
  isDisabled,
  required,
}: any) => {
  return (
    <>
      {label && (
        <Label htmlFor={name} className="form-label">
          {label}
          {required && <span className="text-danger">*</span>}
        </Label>
      )}
      <Select
        value={value}
        className={className ? className : "select-border"}
        isMulti={isMulti}
        onChange={onChange}
        options={options}
        styles={colourStyles}
        invalid={!!(error && touched)}
        name={name}
        onBlur={handleBlur}
        isInvalid={!!(touched && error)}
        isDisabled={isDisabled}
      />
      {touched && error ? (
        <div className="text-danger error-font">{error}</div>
      ) : null}
    </>
  );
};

export { BaseSelect, MultiSelect };
